import React, { useState } from 'react'
import { IoCloseOutline } from "react-icons/io5";
import { IoArrowBackOutline, IoArrowForward } from "react-icons/io5";
import { motion } from 'framer-motion'



const Gallery = ({setModal, data}) => {
  const [preview, setPreview] = useState(0)

  const handleForward = () => {
    setPreview((preview + 1) % data.images.length);

  }

  const handleBackward = () => {
    setPreview((preview - 1 + data.images.length) % data.images.length);
  }

  const handleGallery = (item) => {
    setPreview(item -1)
  }

  return (
    <motion.div
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: [0.1, 0.1, 0.1, 0.3, 0.5, 0.7, 1] }}
     transition={{ duration: 0.7, ease: "easeIn" }}
     exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
     className='relative mb-10 w-full h-full z-50 bg-white pt-5 pb-5 shadow-md rounded-xl md:pt-6 max-w-screen-lg lg:-mt-32 lg:pb-6 xl:-mt-36 xl:pb-8 mx-auto'>

       <div className='flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7'>
          <div className='flex items-center justify-start'>
              <img className='w-4 lg:w-5 xl:w-7' src={data.title_icon} alt='icon' />
              <p className='text-[11px] text-[#101828] font-semibold ml-1.5 md:text-[13px] md:ml-2 lg:text-sm xl:text-lg xl:ml-3'>
                  {data.title}
              </p>
          </div>
          <IoCloseOutline onClick={()=>setModal(false)} className='text-xl lg:text-2xl xl:text-3xl' />
       </div>

       <div className='w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5'></div>

       <div className='flex flex-col items-center justify-start w-full px-5 pb-5 md:px-3 lg:px-3 xl:px-0 xl:pb-8'>
       <div className='flex-col items-center w-full mt-10 md:mt-12 xl:mt-14'>
           {/*PREVIEW IMAGE*/}
           <div className='relative flex flex-col items-center justify-center w-full'>
              <motion.div
               initial={{scale: 1, opacity: 0, }}
               animate={{scale: 1, opacity: [0, 0.1, 0.3, 0.5, 1.0] }}
               transition={{ duration: 0.5, delay: 0.15, easing: "easeOut", }}
               key={data.images[preview].img}
               className='w-full md:w-[85%] md:h-full lg:w-[84%] xl:w-[81%]'>
                  <img className='w-full h-full object-cover rounded-md'
                  src={data.images[preview].img} 
                  alt='preview_image' loading='lazy' />
              </motion.div>

               
               {/*NAVIGATION*/}
               <div className='flex items-center justify-center w-full mt-7 md:absolute md:justify-between md:mb-7 lg:w-[100%] xl:w-[95%]'>
                    <div onClick={handleBackward}
                    className='flex items-center justify-center border-[3px] h-6 w-6 rounded-full mx-10 text-[#25A249] border-[#25A249] hover:bg-[#25A249]
                              hover:text-[#ffffff] md:mx-1 lg:h-7 lg:w-7 xl:mx-0 xl:h-9 xl:w-9 xl:border-[3.5px]'>
                        <IoArrowBackOutline className='text-xl xl:text-[26px]' />
                    </div>
 
                    <div onClick={handleForward}
                    className='flex items-center justify-center border-[3px] h-6 w-6 rounded-full mx-10 text-[#25A249] border-[#25A249] hover:bg-[#25A249]
                               hover:text-[#ffffff] md:mx-1 lg:h-7 lg:w-7 xl:mx-0 xl:h-9 xl:w-9 xl:border-[3.5px]'>
                        <IoArrowForward className='text-xl xl:text-[26px]' />
                    </div>
               </div>

           </div>

       </div>

       <div className='flex items-center justify-start w-full mt-7 md:mt-5 md:px-3 lg:mt-6 xl:px-7'>
          <div className='flex items-center justify-start w-full flex-shrink-0 md:justify-center'>
           {data.images.map((item) => {
            return(
            <div key={item.id} onClick={()=>handleGallery(item.id)}
            className='flex items-center justify-start w-[75px] h-[75px] mt-2 mr-2.5 md:mt-3 md:w-[125px] md:h-[90px] lg:mt-3.5 lg:w-[185px] lg:h-[120px] lg:mr-3.5 xl:h-[100px] xl:mt-[22px] xl:mr-5'>
               <img className={`w-full h-full object-cover rounded-[4px] md:rounded-md xl:rounded-lg ${preview === item.id - 1 && 'border-2 border-[#F1C21B] md:border-[3px] xl:border-4'}`}
               src={item.img} alt='img_1' loading='lazy' />
            </div>
             )
            })}
          </div>

       </div>
       
      </div>


         {/* CLOSE BUTTON */}
         <div className='flex items-center justify-end w-full px-3 md:px-5 lg:px-7 md:mt-1 lg:mt-2 xl:mt-1'>
            <div onClick={()=>setModal(false)}
            className='flex items-center justify-center w-[75px] h-7 rounded-md bg-[#25A249] text-white cursor-pointer md:w-[77px] md:h-7 lg:w-[80px] lg:h-8 xl:h-10 xl:w-28 xl:rounded-lg'>
                <p className='text-[11px] font-normal md:text-xs xl:text-base'>Close</p>
                <IoCloseOutline  className='text-base ml-[6px] md:text-lg md:ml-2 xl:text-2xl' />
            </div>
        </div>

    </motion.div>
  )
}


export default Gallery
